import React from 'react'

export default function Subscriptions(props: React.SVGProps<SVGSVGElement>): React.ReactElement {
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="#747894" {...props}>
    <path d="M23 4v6h-6" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M1 20v-6h6" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M1 14l4.64 4.36A9 9 0 0 0 20.49 15" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
}
